// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
/* eslint-disable -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved. */
import PropTypes from "prop-types";
import { useTheme, useMediaQuery } from "@mui/material";

import { NeedHelp, Agreement } from "@/components/common";
import { Grid, Link, Image } from "@/components/core";
import { AccountEntranceVideo } from "@/components/common/login-video";
import { LanguageSelected } from "@/components/common/language-selected";
import { usePathname } from "next/navigation";

export function AccountEntranceLayout({ children }: any) {
  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down("md"));
  const pathname = usePathname();
  const isRegisterPage = pathname === "/register";

  return (
    <Grid
      sx={{
        minHeight: "100vh",
        overflow: "hidden",
      }}
      alignItems="stretch"
    >
      <Grid.Item
        xs={12}
        md={5}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          px: { xs: 3, md: 10 },
          py: { xs: 3, md: 2 },
          backgroundColor: "#fff",
        }}
      >
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Link href="/login">
            <Image src="/svg/uption-logo.svg" alt="uption-logo" width={154} height={32} />
          </Link>
          <LanguageSelected />
        </Grid>
        <Grid
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
          }}
        >
          <Grid
            sx={{
              width: "100%",
              maxWidth: 340,
              mx: "auto",
              mt: { xs: 6, md: 3 },
            }}
          >
            {children}
          </Grid>
          <Grid
            sx={{
              mt: "auto",
              pb: 6,
              display: "flex",
              flexDirection: isRegisterPage ? "column" : "row",
              flexWrap: isRegisterPage ? "wrap" : "nowrap",
              justifyContent: "space-between",
              alignItems: isRegisterPage ? "flex-start" : "center",
              rowGap: isRegisterPage ? "10px" : 0,
            }}
          >
            <NeedHelp />
            {isRegisterPage && <Agreement sx={{ paddingTop: "20px" }} />}
          </Grid>
        </Grid>
      </Grid.Item>
      <Grid.Item
        xs={12}
        md={7}
        sx={{
          display: { xs: "none", md: "block" },
          minHeight: "100vh",
          position: "relative",
          overflow: "auto",
        }}
      >
        <AccountEntranceVideo />
      </Grid.Item>
    </Grid>
  );
}

AccountEntranceLayout.propTypes = {
  children: PropTypes.node,
};
